import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { caseStudiesData } from '../data/caseStudies';

const SITE_URL = 'https://mdlens.com';

const routeMetadata = {
  '/': ['Customer Acquisition Systems for Local Businesses | Mathias Deppe', 'Clear messaging, premium content and practical sales automation to help local businesses turn attention into customers.'],
  '/about': ['About Mathias Deppe | Digital Growth Consultant Near Barcelona', 'Meet Mathias Deppe and learn how sales, content and automation combine into customer acquisition systems.'],
  '/ai-lead-agent': ['AI Lead Assistant for Instagram DMs | Mathias Deppe', 'Qualify Instagram enquiries, answer common questions and guide prospects toward the next step.'],
  '/beauty-clinic': ['Beauty Clinic Marketing & Lead Automation | Mathias Deppe', 'Help beauty clinics respond to Instagram enquiries and guide suitable prospects toward appointments.'],
  '/fitness-offer': ['Lead Conversion System for Gyms | Mathias Deppe', 'Help gyms qualify Instagram enquiries and prepare coaches for better membership conversations.'],
  '/content-shooting': ['Professional Content Shooting Days | Mathias Deppe', 'Professional photo and short-form video content for businesses in Barcelona and beyond.'],
  '/insights': ['Insights | Practical Customer Acquisition Ideas | Mathias Deppe', 'Practical ideas for customer acquisition, lead conversion and growth for local businesses.'],
  '/portfolio': ['Selected Work | Mathias Deppe', 'Photography and video work created for brands, businesses and creative projects.'],
  '/case-studies': ['Case Studies | Customer Acquisition Projects | Mathias Deppe', 'Explore client projects, the challenges they faced and the outcomes of the work.'],
  '/privacy': ['Privacy Policy | Mathias Deppe', 'Read how Mathias Deppe handles personal data and protects your privacy.'],
  '/terms': ['Terms of Service | Mathias Deppe', 'Terms covering use of the Mathias Deppe website and services.'],
  '/imprint': ['Imprint | Mathias Deppe', 'Legal and contact information for Mathias Deppe.']
};

const insightMetadata = {
  '/insights/5-reasons-gyms-lose-instagram-leads': ['5 Reasons Barcelona Gyms Lose Instagram Leads | Mathias Deppe', 'Common reasons gyms lose Instagram prospects and practical ways to improve the path from enquiry to booking.'],
  '/insights/speed-to-lead-math': ['Speed-to-Lead: Why Response Time Matters | Mathias Deppe', 'Understand why fast responses can matter for converting local business enquiries.'],
  '/insights/beauty-outcomes-vs-treatments': ['Beauty Clinics: Sell Outcomes, Not Treatments | Mathias Deppe', 'Learn how outcome-led messaging can make beauty clinic marketing clearer to potential clients.']
};

const RouteSEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalPath = pathname.replace(/\/+$/, '') || '/';
    const studySlug = canonicalPath.startsWith('/case-studies/')
      ? canonicalPath.split('/').pop()
      : null;
    const study = studySlug
      ? caseStudiesData.find((item) => item.slug === studySlug)
      : null;
    const metadata = insightMetadata[canonicalPath]
      || (study
        ? [`${study[0].toUpperCase()}${study.slice(1).replaceAll('-', ' ')} | Mathias Deppe`, `${study[0].toUpperCase()}${study.slice(1).replaceAll('-', ' ')}: client case study by Mathias Deppe.`]
        : routeMetadata[canonicalPath])
      || ['Mathias Deppe | Customer Acquisition Systems', 'Customer acquisition systems, premium content and practical sales automation for local businesses.'];

    document.title = metadata[0];

    const description = document.head.querySelector('meta[name="description"]');
    if (description) description.setAttribute('content', metadata[1]);

    const canonicalUrl = `${SITE_URL}${canonicalPath}`;
    let canonical = document.head.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);

    const ogUrl = document.head.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);
  }, [pathname]);

  return null;
};

export default RouteSEO;